import { createContext, Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from 'react'

import { useUser } from '@/hooks/useUser'

export type UserFormData = string | number | boolean | object | undefined // "John Doe" | 123 | true | { code: "us", name: "The United States" }

export interface UserFormContextProps {
  userForm: Record<string, UserFormData>
  setUserForm: Dispatch<SetStateAction<UserFormContextProps['userForm']>>
  userUpdatedFields: string[]
  setUserUpdatedFields: Dispatch<SetStateAction<string[]>>
}

export const UserFormContext = createContext({} as UserFormContextProps)

export const UserFormProvider = ({ children }: PropsWithChildren) => {
  const { user } = useUser()
  const [userForm, setUserForm] = useState<UserFormContextProps['userForm']>({})
  const [userUpdatedFields, setUserUpdatedFields] = useState<string[]>([])

  useEffect(() => {
    if (!userForm) return

    localStorage.setItem('userForm', JSON.stringify(userForm))
  }, [userForm])

  useEffect(() => {
    // Refresh userForm with user.data if data exists
    if (!user?.data) return

    setUserForm(user.data)
  }, [user?.data])

  useEffect(() => {
    const lsUserForm = localStorage.getItem('userForm')
    setUserForm(lsUserForm ? JSON.parse(lsUserForm) : {})
  }, [])

  const value = {
    userForm,
    setUserForm,
    userUpdatedFields,
    setUserUpdatedFields
  }

  return <UserFormContext.Provider value={value}>{children}</UserFormContext.Provider>
}
